import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  IconButton,
  Button,
  Tabs,
  Tab,
  Switch,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const cookieTypes = [
    {
      key: "functional",
      title: "Functional cookies",
      description:
        "These cookies are essential for the running of our website. Without these cookies our websites would not function properly. These are saved temporarily as login information and expire once the browser is closed.",
    },
    {
      key: "analytical",
      title: "Analytical cookies",
      description:
        "The information provided by analytical cookies allows us to analyse patterns of visitor behaviour and we use that information to enhance the overall experience or identify areas of the website which may require maintenance. The information is anonymous and is only used for statistical purposes.",
    },
    {
      key: "promotional",
      title: "Promotional cookies",
      description:
        "These cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and more valuable for publishers and advertisers.",
    },
    {
      key: "preferences",
      title: "Preferences cookies",
      description:
        "Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region you are in.",
    },
  ];

const Cookies2 = ({ open, onClose, onAcceptAll, onModify }) => {
  const [tab, setTab] = useState(0);
  const [cookies, setCookies] = useState({
    functional: true,
    analytical: false,
    promotional: false,
    preferences: false,
  });

  const handleToggle = (key) => {
    setCookies((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="paper"
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxHeight: "90vh",
        },
      }}
    >
      {/* Close Button */}
      <Box display="flex" justifyContent="flex-end" px={2} pt={2}>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Content */}
      <DialogContent dividers>
        {/* Title */}
        <Typography variant="h5" fontWeight="bold" mb={2}>
          Your cookie settings
        </Typography>

        {/* Tabs */}
        <Tabs
          value={tab}
          onChange={(_, val) => setTab(val)}
          variant="scrollable"
          allowScrollButtonsMobile
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            mb: 3,
            "& .MuiTab-root": { textTransform: "none", fontWeight: 500 },
          }}
        >
          <Tab label="Change Settings" />
          <Tab label="What are Cookies?" />
          <Tab label="Why are cookies useful?" />
        </Tabs>

        {/* Tab 0: Cookie Switches */}
        {tab === 0 && (
          <Box>
            <Typography fontSize="15px" mb={3}>
              Please select which types of cookies you want to be stored on your device.
            </Typography>

            {cookieTypes.map((cookie) => (
              <Box key={cookie.key} mb={3}>
                <Box display="flex" alignItems="center" mb={1}>
                  <Switch
                    checked={cookies[cookie.key]}
                    onChange={() => handleToggle(cookie.key)}
                    color="primary"
                  />
                  <Typography fontWeight="bold">{cookie.title}</Typography>
                </Box>
                <Typography color="text.secondary" fontSize="14px">
                  {cookie.description}
                </Typography>
              </Box>
            ))}
          </Box>
        )}

        {/* Tab 1 or 2: Placeholder Info */}
        {tab === 1 && (
          <Typography fontSize="15px" color="text.secondary">
            Cookies are small text files stored in your browser that help websites remember
            you and enhance your experience.
          </Typography>
        )}
        {tab === 2 && (
          <Typography fontSize="15px" color="text.secondary">
            Cookies allow us to provide personalized content, improve security, and measure
            traffic for better performance.
          </Typography>
        )}
      </DialogContent>

      {/* Action Buttons */}
      <Box display="flex" justifyContent="space-between" p={3} pt={2}>
        <Button
          onClick={onModify}
          variant="outlined"
          sx={{
            backgroundColor: "rgba(102, 112, 133, 0.1)",
            color: "#3A3F44",
            borderRadius: "10px",
            fontWeight: 500,
            textTransform: "none",
            fontSize: "15px",
            border: "1px solid #ccc",
            flex: 1,
            mr: 2,
          }}
        >
          Modify Preferences
        </Button>
        <Button
          onClick={onAcceptAll}
          variant="contained"
          sx={{
            backgroundColor: "#000",
            color: "#fff",
            borderRadius: "10px",
            fontWeight: 500,
            textTransform: "none",
            fontSize: "15px",
            flex: 1,
            "&:hover": {
              backgroundColor: "#333",
            },
          }}
        >
          Accept All
        </Button>
      </Box>
    </Dialog>
  );
};

export default Cookies2;
